import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

import { BigidMeModal } from '../../../components/BigidMeModal';
import { FieldVerificationsContainer } from './FieldVerificationsContainer';
import { BigidMeIconPinCode } from '../../../assets/icons/BigidMeIconPinCode';
import { LanguageContainer } from '../../../state/languageContainer';
import { StyledLink, StyledToken } from './FieldVerificationsStyles';
import { e2e } from '../../../utils';

export const FieldVerificationsDialog = () => {
  const { openVerifyDialog, dialogData } = FieldVerificationsContainer.useContainer();
  const { BigIdMeTranslate, BigIdMeTranslateWithNode } = LanguageContainer.useContainer();

  return (
    <BigidMeModal open={openVerifyDialog}>
      <Box textAlign="center">
        <Box my={2}>
          <BigidMeIconPinCode />
        </Box>
        <Typography variant="h4" color="textPrimary" mb={3}>
          {BigIdMeTranslateWithNode('consumer_web_verification', [
            {
              key: 'field_name',
              value: dialogData?.fieldLabel,
            },
          ])}
        </Typography>
        <Typography variant="h6" color="textPrimary" fontWeight={400} mb={3}>
          {BigIdMeTranslate('consumer_web_nafath_verification_subtitle')}
        </Typography>
        {dialogData?.token && <StyledToken data-aid="verification-token-number">{dialogData?.token}</StyledToken>}{' '}
        <Divider />
        <Typography variant="subtitle2" color="textPrimary" align="center" gutterBottom mt={2}>
          {BigIdMeTranslate('consumer_web_sms_didnt-get-code')}{' '}
          <StyledLink onClick={dialogData?.resend} {...e2e(`verify_resend_button`)}>
            {BigIdMeTranslate('consumer_web_resend')}
          </StyledLink>
        </Typography>
      </Box>
    </BigidMeModal>
  );
};
